import { ProgramState } from '@/utils/programs';
import { WorkflowWorkflowType } from '@calm/evexia-web-sdk';
import { useCallback, useMemo } from 'react';
import { useUserBlocker } from '../use-user-blocker';
import { UserBlocker } from '../use-user-blocker/types';

export default function useIsContentLocked() {
    const { userBlocker } = useUserBlocker();

    const isUnsponsored = useMemo(
        () => userBlocker === UserBlocker.Unsponsored,
        [userBlocker]
    );

    const getIsContentLocked = useCallback(
        ({
            programState,
            programType,
        }: {
            programState: ProgramState;
            programType?: WorkflowWorkflowType;
        }) => {
            // if a user has already started a clinical program, they should still have access even if they become unsponsored
            const isInProgressClinicalProgram =
                programState === ProgramState.InProgress &&
                programType === WorkflowWorkflowType.ClinicalProgram;

            if (isInProgressClinicalProgram) {
                return false;
            }
            return isUnsponsored;
        },
        [isUnsponsored]
    );

    return { getIsContentLocked };
}
